import
{
  getStaticMessage,
  getCountries,
  getProvinces,
  companyData,
  userInCompanies,
  getUserInCompaniesbyUserId,
  getUserCompanyDatabyComapanyId,
} from '@/services/eserv-api';
import getMelissaAddresses from '@/services/melissa-api';
import {
  getUsers,
  getUserList,
  getSCCUserList,
  getSCCUserEventLog,
  getUserDetails,
  getUserProfiles,
  getSecurityQuestions,
  register,
  resetPassword,
  usersSecurityQuestions,
  updateUsersSecurityQuestions,
  getUserProfilesById,
  userProfiles,
  userPhones,
  getUserContacts,
  updateUserContacts,
  changePassword,
  getRoles,
  userInRoles,
  deactivateUser,
  activateUser,
  getUserPasswordLogById,
  unlockUser,
  getUserNotes,
  setUserNotes,
  deleteUserNotes,
} from './services/users-api';
import { getCompanies } from '../auth/services/tms-api';
import { dataStates, DataSetStatus } from '../../store/shared/DataSetStatusModels';

export const SET_USERS = 'users/SET_USERS';
export const SET_USERPROFILES = 'users/SET_USERPROFILES';
export const ACTIVE_USER_LIST = 'users/ACTIVE_USER_LIST';
export const INACTIVE_USER_LIST = 'users/INACTIVE_USER_LIST';
export const LOCKED_USER_LIST = 'users/LOCKED_USER_LIST';
export const FETCH_USERS = 'users/FETCH_USERS';
export const FETCH_USER_PROFILES = 'users/FETCH_USER_PROFILES';
export const FETCH_ACTIVE_INACTIVE_USERS = 'users/FETCH_AUCTIVE_INACTIVE_USERS';
export const FETCH_SCC_USERS = 'users/FETCH_SCC_USERS';
export const SET_SCC_USERS = 'users/SET_SCC_USERS';
export const FETCH_SCC_USERS_EVENT_LOG = 'users/FETCH_SCC_USERS_EVENT_LOG';
export const SET_SCC_USERS_EVENT_LOG = 'users/SET_SCC_USERS_EVENT_LOG';
export const FETCH_WEB_USERS_EVENT_LOG = 'users/FETCH_WEB_USERS_EVENT_LOG';
export const SET_WEB_USERS_EVENT_LOG = 'users/SET_WEB_USERS_EVENT_LOG';
export const GET_ROLES = 'users/GET_ROLES';
export const USER_IN_ROLES = 'users/USER_IN_ROLES';
export const SECURITY_QUESTIONS = 'auth/SECURITY_QUESTIONS';
export const SET_SECURITY_QUESTIONS = 'auth/SET_SECURITY_QUESTIONS';
export const STATIC_MESSAGE = 'api/STATIC_MESSAGE';
export const SET_STATIC_MESSAGE = 'api/SET_STATIC_MESSAGE';
export const GET_COUNTRIES = 'api/GET_COUNTRIES';
export const GET_PROVINCES = 'api/GET_PROVINCES';
export const SET_COUNTRIES = 'api/SET_COUNTRIES';
export const SET_PROVINCES = 'api/SET_PROVINCES';
export const GET_COMPANIES = 'api/GET_COMPANIES';
export const SET_COMPANIES = 'api/SET_COMPANIES';
export const COMPANY_DATA = 'api/COMPANY_DATA';
export const REGISTER = 'auth/REGISTER';
export const USER_SECURITY_QUESTIONS = 'auth/USER_SECURITY_QUESTIONS';
export const UPDATE_USER_SECURITY_QUESTIONS = 'auth/UPDATE_USER_SECURITY_QUESTIONS';
export const USER_PROFILES = 'auth/USER_PROFILES';
export const USER_PHONES = 'auth/USER_PHONES';
export const GET_MELISSA_ADDRESSES = 'api/GET_MELISSA_ADDRESSES';
export const SET_MELISSA_ADDRESSES = 'api/SET_MELISSA_ADDRESSES';
export const GET_USER_PROFILES_BY_ID = 'auth/GET_USER_PROFILES_BY_ID';
export const SET_USER_PROFILES_BY_ID = 'auth/SET_USER_PROFILES_BY_ID';
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const GET_USER_COMAPNY_DATA_BY_ID = 'api/GET_USER_COMAPNY_DATA_BY_ID';
export const SET_USER_COMAPNY_DATA_BY_ID = 'api/SET_USER_COMAPNY_DATA_BY_ID';
export const GET_USER_CONTACTS = 'auth/GET_USER_CONTACTS';
export const SET_USER_CONTACTS = 'auth/SET_USER_CONTACTS';
export const UPDATE_USER_CONTACTS = 'auth/UPDATE_USER_CONTACTS';
export const CHANGE_PASSWORD = 'auth/CHANGE_PASSWORD';
export const SET_CHANGE_PASSWORD_RESP = 'auth/SET_CHANGE_PASSWORD_RESP';
export const GET_USER_DETAILS = 'users/GET_USER_DETAILS';
export const DEACTIVATE_USER = 'users/DEACTIVATE_USER';
export const ACTIVATE_USER = 'users/ACTIVATE_USER';
export const UNLOCK_USER = 'users/UNLOCK_USER';
export const GET_PASSWORD_LOGS = 'auth/GET_PASSWORD_LOGS';
export const SET_PASSWORD_LOGS = 'auth/SET_PASSWORD_LOGS';
export const SET_USER_NOTES = 'users/SET_USER_NOTES';
export const SET_USER_NOTES_BY_ID = 'users/SET_USER_NOTES_BY_ID';
export const FETCH_USER_NOTES = 'users/FETCH_USER_NOTES';
export const DELETE_USER_NOTES = 'users/DELETE_USER_NOTES';

const SET_COMPANY_DATASET_STATUS = 'auth/SET_COMPANY_DATASET_STATUS';

export const usersStore = {
  state: {
    users: null,
    userProfiles: null,
    activeUsers: null,
    inactiveUsers: null,
    lockedUsers: null,
    sccUserList: null,
    sccUserEventLogList: null,
    securityQuestions: null,
    staticMessage: null,
    countries: null,
    provinces: null,
    companies: null,
    melissaAddresses: null,
    userProfilesbyID: null,
    userCompanyDatabyID: null,
    userContactsbyUserID: null,
    chnagePasswordResponse: null,
    passwordLogs: null,
    webUserEventLogList: null,
    companyDataSetStatus: new DataSetStatus(),
    userNotes: null,
  },
  mutations: {
    [SET_USERS](state, { users }) {
      state.users = users;
    },
    [SET_USERPROFILES](state, { _payload }) {
      state.userProfiles = _payload;
    },
    [ACTIVE_USER_LIST](state, { activeUserList }) {
      state.activeUsers = activeUserList;
    },
    [INACTIVE_USER_LIST](state, { inactiveUserList }) {
      state.inactiveUsers = inactiveUserList;
    },
    [LOCKED_USER_LIST](state, { lockedUserList }) {
      state.lockedUsers = lockedUserList;
    },
    [SET_SCC_USERS](state, { sccUserList }) {
      state.sccUserList = sccUserList;
    },
    [SET_SCC_USERS_EVENT_LOG](state, { sccUserEventLogList }) {
      state.sccUserEventLogList = sccUserEventLogList;
    },
    [SET_WEB_USERS_EVENT_LOG](state, { webUserEventLogList }) {
      state.webUserEventLogList = webUserEventLogList;
    },
    [SET_SECURITY_QUESTIONS](state, { securityQuestions }) {
      state.securityQuestions = securityQuestions;
    },
    [SET_STATIC_MESSAGE](state, { staticMessage }) {
      state.staticMessage = staticMessage;
    },
    [SET_COUNTRIES](state, { countries }) {
      state.countries = countries;
    },
    [SET_PROVINCES](state, { provinces }) {
      state.provinces = provinces;
    },
    [SET_COMPANIES](state, { companies }) {
      if (companies !== null) {
        companies.forEach((company) => {
        // eslint-disable-next-line no-return-assign, no-param-reassign
          company.text = `${company.legalName}, ${company.address}, ${company.cityName}, ${company.countryName}`;
        });
      }
      state.companies = companies;
    },
    [SET_COMPANY_DATASET_STATUS](state, { status }) {
      state.companyDataSetStatus.status = status;
    },
    [SET_MELISSA_ADDRESSES](state, { melissaAddresses }) {
      state.melissaAddresses = melissaAddresses;
    },
    [SET_USER_PROFILES_BY_ID](state, { userProfilesbyID }) {
      state.userProfilesbyID = userProfilesbyID;
    },
    [SET_USER_COMAPNY_DATA_BY_ID](state, { userCompanyDatabyID }) {
      if (userCompanyDatabyID !== null) {
        // eslint-disable-next-line no-return-assign, no-param-reassign
        userCompanyDatabyID.text = `${userCompanyDatabyID.legalName}, ${userCompanyDatabyID.address}, ${userCompanyDatabyID.cityName}, ${userCompanyDatabyID.countryName}`;
      }
      state.userCompanyDatabyID = userCompanyDatabyID;
    },
    [SET_USER_CONTACTS](state, { userContactsbyUserID }) {
      state.userContactsbyUserID = userContactsbyUserID;
    },
    [SET_CHANGE_PASSWORD_RESP](state, { chnagePasswordResponse }) {
      state.chnagePasswordResponse = chnagePasswordResponse;
    },
    [SET_PASSWORD_LOGS](state, { passwordLogs }) {
      state.passwordLogs = passwordLogs;
    },
    [SET_USER_NOTES](state, { userNotes }) {
      state.userNotes = userNotes;
    },
  },
  getters: {
    users: (state) => state.users,
    userProfiles: (state) => state.userProfiles,
    activeUsers: (state) => state.activeUsers,
    inactiveUsers: (state) => state.inactiveUsers,
    lockedUsers: (state) => state.lockedUsers,
    sccUserList: (state) => state.sccUserList,
    securityQuestions: (state) => state.securityQuestions,
    staticMessage: (state) => state.staticMessage,
    countries: (state) => state.countries,
    provinces: (state) => state.provinces,
    companies: (state) => state.companies,
    melissaAddresses: (state) => state.melissaAddresses,
    userProfilesbyID: (state) => state.userProfilesbyID,
    userCompanyDatabyID: (state) => state.userCompanyDatabyID,
    userContactsbyUserID: (state) => state.userContactsbyUserID,
    chnagePasswordResponse: (state) => state.chnagePasswordResponse,
    passwordLogs: (state) => state.passwordLogs,
    webUserEventLogList: (state) => state.webUserEventLogList,
    sccUserEventLogList: (state) => state.sccUserEventLogList,
    userNotes: (state) => state.userNotes,
  },
  actions: {
    [FETCH_USERS]: async ({ commit }) => {
      try {
        commit(SET_USERS, { users: null });
        const resp = await getUsers();
        commit(SET_USERS, { users: resp.data });
        return resp;
      } catch (error) {
        console.error(`fetch_user:${error.Status}`);
        // console.log(error);
        throw error;
      }
    },
    [FETCH_ACTIVE_INACTIVE_USERS]: async ({ commit }) => {
      try {
        commit(SET_USERS, { activeUserList: null });
        commit(SET_USERS, { inactiveUserList: null });
        await getUserList()
          .then((resp) => {
            const activeUserList = [];
            const inactiveUserList = [];
            const lockedUserList = [];
            for (let i = 0; i < resp.data.length; i += 1) {
              if (resp.data[i].memberShip.isLockedOut) {
                lockedUserList.push(resp.data[i]);
              } else if (resp.data[i].memberShip.isApproved) {
                activeUserList.push(resp.data[i]);
              } else {
                inactiveUserList.push(resp.data[i]);
              }
            }
            commit(ACTIVE_USER_LIST, { activeUserList });
            commit(INACTIVE_USER_LIST, { inactiveUserList });
            commit(LOCKED_USER_LIST, { lockedUserList });
          });
      } catch (error) {
        // return Promise.reject(error);
        console.error(`SCC_USERS:${error.Status}`);
        // throw error;
      }
    },
    [FETCH_SCC_USERS]: async ({ commit }) => {
      try {
        commit(SET_SCC_USERS, { sccUserList: null });
        // const resp = await getSCCUserList();
        return await getSCCUserList()
          .then((resp) => {
            commit(SET_SCC_USERS, { sccUserList: resp.data });
            return resp;
          });
        // commit(SET_SCC_USERS, { sccUserList: resp.data });
      } catch (error) {
        return Promise.reject(error);
        // console.error(`SCC_USERS:${error.Status}`);
        // throw error;
      }
    },
    [FETCH_SCC_USERS_EVENT_LOG]: async ({ commit }) => {
      try {
        const isSccUser = true;
        commit(SET_SCC_USERS_EVENT_LOG, { sccUserEventLogList: null });
        await getSCCUserEventLog(isSccUser)
          .then((resp) => {
            commit(SET_SCC_USERS_EVENT_LOG, { sccUserEventLogList: resp.data });
          });
      } catch (error) {
        // return Promise.reject(error);
        console.error(`SCC_USERS_Event:${error.Status}`);
        // throw error;
      }
    },
    [FETCH_WEB_USERS_EVENT_LOG]: async ({ commit }) => {
      try {
        const isSccUser = false;
        commit(SET_WEB_USERS_EVENT_LOG, { webUserEventLogList: null });
        await getSCCUserEventLog(isSccUser)
          .then((resp) => {
            commit(SET_WEB_USERS_EVENT_LOG, { webUserEventLogList: resp.data });
          });
      } catch (error) {
        // return Promise.reject(error);
        console.error(`SCC_USERS_Event:${error.Status}`);
        // throw error;
      }
    },
    [GET_ROLES]: async () => {
      try {
        return await getRoles()
          .then((resp) => resp);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    [GET_USER_DETAILS]: async (_, payload) => {
      try {
        const { userName } = payload;
        return await getUserDetails(userName)
          .then((resp) => resp);
      } catch (error) {
        return Promise.reject(error);
        // console.error(`userDetails:${error.Status}`);
        // throw error;
      }
    },
    [FETCH_USER_PROFILES]: async ({ commit }) => {
      try {
        commit(SET_USERPROFILES, { _payload: null });
        const resp = await getUserProfiles();
        commit(SET_USERPROFILES, { _payload: resp.data });
        return resp;
      } catch (error) {
        console.error(`fetch_user:${error.Status}`);
        // console.log(error);
        throw error;
      }
    },
    [USER_IN_ROLES]: async (_, payload) => {
      try {
        const data = payload;
        return await userInRoles(data)
          .then((resp) => resp);
      } catch (error) {
        return Promise.reject(error);
        // console.error(`roles:${error.Status}`);
        // throw error;
      }
    },
    [SECURITY_QUESTIONS]: async ({ commit }) => {
      commit(SET_SECURITY_QUESTIONS, { securityQuestions: null });
      const resp = await getSecurityQuestions();
      commit(SET_SECURITY_QUESTIONS, { securityQuestions: resp.data });
    },
    [STATIC_MESSAGE]: async ({ commit }, payload) => {
      try {
        const { messageType } = payload;
        const resp = await getStaticMessage(messageType);
        commit(SET_STATIC_MESSAGE, { staticMessage: resp.data.message });
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    [GET_COUNTRIES]: async ({ commit }) => {
      commit(SET_COUNTRIES, { countries: null });
      const resp = await getCountries();
      commit(SET_COUNTRIES, { countries: resp.data });
    },
    [GET_PROVINCES]: async ({ commit }) => {
      commit(SET_PROVINCES, { provinces: null });
      const resp = await getProvinces();
      commit(SET_PROVINCES, { provinces: resp.data });
    },
    [GET_COMPANIES]: async ({ state, commit }) => {
      if (state.companyDataSetStatus.status === dataStates.loaded) {
        return state.companies;
      }

      if (state.companyDataSetStatus.status === dataStates.notSet) {
        commit(SET_COMPANIES, { companies: null });
        commit(SET_COMPANY_DATASET_STATUS, { status: dataStates.loading });

        state.companyDataSetStatus.dataPromise = getCompanies().then((resp) => {
          commit(SET_COMPANIES, { companies: resp.data });
          commit(SET_COMPANY_DATASET_STATUS, { status: dataStates.loaded });
          return state.companies;
        }).catch((error) => {
          console.error(error);
          commit(SET_COMPANY_DATASET_STATUS, { status: dataStates.error });
          state.companyDataSetStatus.dataPromise.reject('Failed to load the companies', error);
          return state.companies;
        });

        return state.companyDataSetStatus.dataPromise;
      }
      return state.companyDataSetStatus.dataPromise;
    },
    [GET_MELISSA_ADDRESSES]: async ({ commit }, payload) => {
      const { melissaAddress1, melissaCountry } = payload;
      const resp = await getMelissaAddresses.getMelissaAddresses(melissaAddress1, melissaCountry);
      commit(SET_MELISSA_ADDRESSES, { melissaAddresses: resp.d.Results });
    },
    [COMPANY_DATA]: async (_, payload) => {
      try {
        const {
          legalName,
          phoneNumber,
          faxNumber,
          address,
          addressLine2,
          cityName,
          postalCode,
          provinceName,
          countryName,
          username,
          source,
          sourceCompanyId,
        } = payload;
        const resp = await companyData(
          legalName,
          phoneNumber,
          faxNumber,
          address,
          addressLine2,
          cityName,
          postalCode,
          provinceName,
          countryName,
          username,
          source,
          sourceCompanyId,
        );
        if (resp.data !== null) {
          const { userId } = payload;
          const { companyId } = resp.data;
          await userInCompanies(userId, companyId, username);
        }
      } catch (error) {
        console.error(error.Status);
        throw error;
      }
    },
    [GET_USER_COMAPNY_DATA_BY_ID]: async ({ commit }, payload) => {
      try {
        commit(SET_USER_COMAPNY_DATA_BY_ID, { userCompanyDatabyID: null });
        const { userId } = payload;
        const resp = await getUserInCompaniesbyUserId(userId);
        if (resp.data !== null && resp.data !== '') {
          const data = await getUserCompanyDatabyComapanyId(resp.data.companyId);
          commit(SET_USER_COMAPNY_DATA_BY_ID, { userCompanyDatabyID: data.data });
        }
      } catch (error) {
        console.error(`company_err:${error.Status}`);
        throw error;
      }
    },
    [REGISTER]: async (_, payload) => {
      try {
        const {
          username, email, password, forcePasswordChange, isSCCUser,
        } = payload;
        await register(username, email, password, forcePasswordChange, isSCCUser);
        // console.log(resp);
      } catch (error) {
        console.error(`account register_err:${error.Status}`);
        throw error;
      }
    },
    [USER_SECURITY_QUESTIONS]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('data:', data);
        await usersSecurityQuestions(data);
      } catch (error) {
        console.error(`securityquestion_err:${error.Status}`);
        throw error;
      }
    },
    [UPDATE_USER_SECURITY_QUESTIONS]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await updateUsersSecurityQuestions(data);
      } catch (error) {
        console.error(`securityquestion_err:${error.Status}`);
        throw error;
      }
    },
    [USER_PROFILES]: async (_, payload) => {
      try {
        await userProfiles(payload);
      } catch (error) {
        console.error(`profile_err:${error.Status}`);
        throw error;
      }
    },
    [USER_PHONES]: async (_, payload) => {
      try {
        const {
          phoneType, phoneNumber, ext, userId, isDefault,
        } = payload;
        await userPhones(phoneType, phoneNumber, ext, userId, isDefault);
      } catch (error) {
        console.error(`phone_err:${error.Status}`);
        throw error;
      }
    },
    [GET_USER_PROFILES_BY_ID]: async ({ commit }, payload) => {
      try {
        const { userId } = payload;
        const resp = await getUserProfilesById(userId);
        // return await userInRoles(data)
        //     .then((resp) => resp);
        // console.log('Store Response:', resp);
        commit(SET_USER_PROFILES_BY_ID, { userProfilesbyID: resp.data[0] });
      } catch (error) {
        console.error(`load profile_err:${error}`);
        throw error;
      }
    },
    [RESET_PASSWORD]: async (_, payload) => {
      try {
        const { userId, password, forcePasswordChange } = payload;
        return await resetPassword(userId, password, forcePasswordChange).then((resp) => resp);
        // console.log(resp);
      } catch (error) {
        console.error(`reset password_err:${error.Status}`);
        throw error;
      }
    },
    [GET_USER_CONTACTS]: async ({ commit }, payload) => {
      const {
        userId,
      } = payload;
      const resp = await getUserContacts(
        userId,
      );
      commit(SET_USER_CONTACTS, { userContactsbyUserID: resp.data });
    },
    [UPDATE_USER_CONTACTS]: async (_, payload) => {
      try {
        const { data } = payload;
        await updateUserContacts(data);
      } catch (error) {
        console.error(`userContacts:${error.Status}`);
        throw error;
      }
    },
    [CHANGE_PASSWORD]: async ({ commit }, payload) => {
      try {
        commit(SET_CHANGE_PASSWORD_RESP, { chnagePasswordResponse: null });
        const { username, oldPassword, password } = payload;
        await changePassword(username, oldPassword, password);
        commit(SET_CHANGE_PASSWORD_RESP, { chnagePasswordResponse: 'SUCCESS' });
      } catch (error) {
        console.error(error);
        commit(SET_CHANGE_PASSWORD_RESP, { chnagePasswordResponse: error.response.data.message });
      }
    },
    [DEACTIVATE_USER]: async (_, payload) => {
      try {
        const { userName } = payload;
        return await deactivateUser(userName).then((resp) => resp);
      } catch (error) {
        // console.log(error);
        return Promise.reject(error);
      }
    },
    [ACTIVATE_USER]: async (_, payload) => {
      try {
        const { userName } = payload;
        return await activateUser(userName).then((resp) => resp);
      } catch (error) {
        // console.log(error);
        return Promise.reject(error);
      }
    },
    [UNLOCK_USER]: async (_, payload) => {
      try {
        const { userName } = payload;
        return await unlockUser(userName).then((resp) => resp);
      } catch (error) {
        // console.log(error);
        return Promise.reject(error);
      }
    },
    [GET_PASSWORD_LOGS]: async ({ commit }, payload) => {
      try {
        const { userId } = payload;
        commit(SET_PASSWORD_LOGS, { passwordLogs: null });
        const resp = await getUserPasswordLogById(userId);
        commit(SET_PASSWORD_LOGS, { passwordLogs: resp.data });
      } catch (error) {
        console.error(`load password logs errors:${error}`);
        throw error;
      }
    },
    [FETCH_USER_NOTES]: async ({ commit }, payload) => {
      const {
        userId,
      } = payload;
      try {
        commit(SET_USER_NOTES, { userNotes: null });
        const resp = await getUserNotes(
          userId,
        );
        const { data } = resp;
        commit(SET_USER_NOTES, { userNotes: data });
        return resp;
      } catch (error) {
        console.error(`fetch_user_notes:${error.Status}`);
        throw error;
      }
    },
    [SET_USER_NOTES_BY_ID]: async (_, payload) => {
      try {
        const { data } = payload;
        await setUserNotes(data);
      } catch (error) {
        console.error(`save_user_notes:${error.Status}`);
        throw error;
      }
    },
    [DELETE_USER_NOTES]: async (_, payload) => {
      try {
        const ID = payload;
        const resp = await deleteUserNotes(ID);
        return resp.data;
      } catch (error) {
        console.error('delete_user_notes: ', error);
        throw error;
      }
    },
  },
};
